import {Stack} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid';
import {UserNameWithAvatar} from './UserNameWithAvatar';
import IsActiveStatus from '../../../ui/is-active-status/IsActiveStatus';
import {IUserAccount} from '../../../shared/types/user-account.types';

const renderFullName = ({row}: {row: IUserAccount}) => <UserNameWithAvatar row={row} />;

const renderPosition = ({row}: {row: IUserAccount}) => row.position || '';

const renderEmail = ({row}: {row: IUserAccount}) => row.email || '-';

const renderPhoneNumber = ({row}: {row: IUserAccount}) => row.phoneNumber;

const renderIsActiveStatus = ({row}: {row: IUserAccount}) => (
  <Stack direction="row" height="100%" alignItems="center">
    <IsActiveStatus isActive={row.active} />
  </Stack>
);

export const columns: GridColDef<IUserAccount>[] = [
  {
    field: 'fullName',
    headerName: 'ФИО',
    renderCell: renderFullName,
    sortable: false,
  },
  {
    field: 'position',
    headerName: 'Должность',
    renderCell: renderPosition,
  },
  {
    field: 'email',
    headerName: 'Электронная почта',
    renderCell: renderEmail,
  },
  {
    field: 'phoneNumber',
    headerName: 'Телефон',
    renderCell: renderPhoneNumber,
  },
  {
    field: 'isActive',
    headerName: 'Статус',
    minWidth: 94,
    renderCell: renderIsActiveStatus,
  },
];
